//import * as React from "react";
//import appSettings from "../appSettings";

function cancelButton() {
    //return (
    //    <button type="button" className="btn btn-wmata" onClick={cancelButtonHandler}>Cancel</button>
    //);
    return null;
}

//function cancelButtonHandler() {
//    location.pathname = appSettings.REACT_APP_ROOT_URL + "exit";
//}

export const CancelButton = cancelButton;


// WEBPACK FOOTER //
// ./src/components/cancelButton.tsx